export default "__VITE_ASSET__6bb7e0ca__"